import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import HowIAccompany from "../components/HowIAccompany";
import Matrum from "../components/Matrum";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-crema overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <HowIAccompany />
        <Matrum />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
